// extracted by mini-css-extract-plugin
export var active = "_2g-d";
export var blink = "_2g-e";
export var container = "_2g-5";
export var controls = "_2g-0";
export var controlsRight = "_2g-1";
export var fakeCursor = "_2g-c";
export var hidden = "_2g-b";
export var quillContainerSmall = "_2g-7";
export var quillEditor = "_2g-6";
export var quillEditorSmall = "_2g-8";
export var quillFormatButtons = "_2g-a";
export var quillToolbar = "_2g-9";
export var removePadding = "_2g-2";
export var state = "_2g-3";
export var stateTitle = "_2g-4";